<template>
  <!-- 拆单 -->
  <div>
    <!-- 查询条件 -->
    <div ref="queryForm" style="margin-bottom: 20px">
      <el-form class="glo_form" label-position="left">
        <el-form-item class="queryItems" label="主运单号" style="width: 300px">
          <el-input
            readonly
            v-model="waybillNumber"
            style="width: 100%"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <!-- 表格 -->
    <div class="glo_Table">
      <div class="h3title">待拆货物</div>
      <el-table
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        >
        </el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in tabelHeadeTitle">
          <el-table-column
            v-if="item.field == 'waybillStatusShow' && item.isShow"
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
          >
            <template slot-scope="scope">
              <div
                style="color: #f00"
                v-if="scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'"
              >
                {{ scope.row.waybillStatusShow }}
              </div>
              <div v-else>{{ scope.row.waybillStatusShow }}</div>
            </template>
          </el-table-column>
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-else-if="item && item.isShow"
          >
          </el-table-column>
        </template>
        <el-table-column fixed="right" label="操作" min-width="70px">
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                @click.stop="chaiHuo(scope.row, scope.$index)"
                >拆货</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 拆分按钮 -->
    <div style="margin: 20px 0">
      <el-button
        :class="
          tableData.length == 0
            ? 'glo_btnItems'
            : 'glo_btnItems glo_bgcMainColor'
        "
        @click="addBtns"
        >拆分成子运单
      </el-button>
    </div>

    <!-- 子运单 -->
    <!-- 表格 -->
    <div v-if="childWayList.length > 0">
      <div class="glo_Table" v-for="(item, index) in childWayList" :key="index">
        <div class="h3title chaiDanTit">
          <div>子运单 {{ index + 1 }}</div>
          <el-button class="glo_btnItems delBtn" @click="delBtns(index)"
            >移除
          </el-button>
        </div>
        <el-table
          header-align="center"
          @row-click="rowclick"
          :data="item.childTableData"
          border
          stripe
          :highlight-current-row="true"
          show-summary
          :summary-method="getSummaries"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            fixed="left"
            align="center"
            label="序号"
            type="index"
            width="60"
          >
          </el-table-column>
          <!-- <el-table-column
            fixed="left"
            align="center"
            type="selection"
            width="60"
          ></el-table-column> -->
          <template v-for="(item, index) in tabelHeadeTitle">
            <el-table-column
              v-if="item.field == 'waybillStatusShow' && item.isShow"
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
            >
              <template slot-scope="scope">
                <div
                  style="color: #f00"
                  v-if="scope.row.waybillStatus == 'yi_zuo_fei:waybill_status'"
                >
                  {{ scope.row.waybillStatusShow }}
                </div>
                <div v-else>{{ scope.row.waybillStatusShow }}</div>
              </template>
            </el-table-column>
            <el-table-column
              :key="index"
              :label="item.name"
              :prop="item.field"
              align="center"
              sortable
              :show-overflow-tooltip="true"
              :min-width="item.width"
              :data-isTotal="item.isTotal"
              v-else-if="item && item.isShow"
            >
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>

    <!-- 保存按钮 -->
    <div class="saveBtns">
      <el-button style="margin-right: 40px" @click="goBack">返回 </el-button>
      <el-button
        :disabled="childWayList.length == 0"
        :class="
          childWayList.length == 0
            ? 'glo_btnItems'
            : 'glo_btnItems glo_bgcMainColor'
        "
        @click="submitBtns"
        >保存提交
      </el-button>
    </div>

    <!-- 拆货 -->
    <myDialog
      :diaWidth="diaWidth"
      :dialogTitle="dialogTitle"
      :isShowDialog="isShowDialog"
      @handleCloseDia="handleCloseDia"
      @diaCancelBtn="handleCloseDia"
      @diaConfirmBtn="diaConfirmBtn('dialogFormRef2')"
    >
      <div class="glo_dialogForm">
        <div class="diaTopTitle">
          <div style="margin-bottom: 5px">
            提货单号: {{ mainData.takeAddrNumber }}
          </div>
          <div class="infoBox">
            <div class="infoItem">
              <div class="infoLeft">总件数:</div>
              <div class="infoRight">{{ mainData.packageCout }},</div>
            </div>
            <div class="infoItem">
              <div class="infoLeft">毛重:</div>
              <div class="infoRight">{{ mainData.grossWeight }}KG,</div>
            </div>
            <div class="infoItem">
              <div class="infoLeft">净重:</div>
              <div class="infoRight">{{ mainData.netWeight }}KG,</div>
            </div>
            <div class="infoItem">
              <div class="infoLeft">体积重量:</div>
              <div class="infoRight">{{ mainData.volumeWeight }}KG,</div>
            </div>
            <div class="infoItem">
              <div class="infoLeft">计费取值:</div>
              <div class="infoRight">{{ mainData.billingWeight }}KG,</div>
            </div>
            <div class="infoItem">
              <div class="infoLeft">体积:</div>
              <div class="infoRight">{{ mainData.volume }}m³,</div>
            </div>
          </div>
        </div>
        <div class="glo_Table">
          <el-table
            show-summary
            header-align="center"
            :data="tableData2"
            border
          >
            <el-table-column
              fixed="left"
              align="center"
              label="序号"
              type="index"
              width="60"
            >
            </el-table-column>
            <el-table-column
              fixed="left"
              align="center"
              type="selection"
              width="60"
            ></el-table-column>

            <el-table-column
              label="货物编号"
              prop="goodsNumber"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              label="货物名称"
              prop="goodsName"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
              label="件数"
              prop="packageCout"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  type="number"
                  v-model="tableData2[scope.$index].packageCout"
                  @input="inputNums($event, scope.$index, 'packageCout')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="毛重"
              prop="grossWeight"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  type="number"
                  v-model="tableData2[scope.$index].grossWeight"
                  @input="inputNums($event, scope.$index, 'grossWeight')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="净重"
              prop="netWeight"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  type="number"
                  v-model="tableData2[scope.$index].netWeight"
                  @input="inputNums($event, scope.$index, 'netWeight')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="体积重量"
              prop="volumeWeight"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  type="number"
                  v-model="tableData2[scope.$index].volumeWeight"
                  @input="inputNums($event, scope.$index, 'volumeWeight')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="计费取值"
              prop="billingWeight"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  type="number"
                  v-model="tableData2[scope.$index].billingWeight"
                  @input="inputNums($event, scope.$index, 'billingWeight')"
                ></el-input>
              </template>
            </el-table-column>
            <el-table-column
              label="体积/m³"
              prop="volume"
              align="center"
              sortable
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <el-input
                  placeholder="请输入"
                  type="number"
                  v-model="tableData2[scope.$index].volume"
                  @input="inputNums($event, scope.$index, 'volume')"
                ></el-input>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </myDialog>
  </div>
</template>
<script>
import myDialog from "@/components/Dialog.vue";
export default {
  inject: ["reload"],
  components: {
    myDialog,
  },
  data() {
    return {
      tableData: [],
      tableData2: [],
      selectTableData: [],
      totalArr: [],
      waybillNumber: "",
      // 默认表头
      tabelHeadeTitle: [
        {
          name: "提货单号",
          field: "takeAddrNumber",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "提货地址",
          field: "address",
          width: "200",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物编号",
          field: "goodsNumber",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "品类",
          field: "itemCategoryName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "包装",
          field: "packageName",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积重量",
          field: "volumeWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "130",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "规格",
          field: "specs",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      tabelHeadeTitle2: [
        {
          name: "货物编号",
          field: "goodsNumber",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "货物名称",
          field: "goodsName",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "件数",
          field: "packageCout",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "毛重",
          field: "grossWeight",
          width: "80",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "净重",
          field: "netWeight",
          width: "100",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积重量",
          field: "volumeWeight",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "计费取值",
          field: "billingWeight",
          width: "130",
          sort: 3,
          isShow: true, //是否展示
          isTotal: false, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
        {
          name: "体积/m³",
          field: "volume",
          width: "106",
          sort: 3,
          isShow: true, //是否展示
          isTotal: true, //是否开启合计
          isSort: true, //表格设置里面是否可以排序
        },
      ],
      childWayList: [
        // {
        //   childTableData: [],
        // },
      ],
      myId: 0,
      delIdx: 0,
      // ==== 弹窗组件属性 start ====
      isShowDialog: false,
      dialogTitle: "拆货",
      diaWidth: "70%",
      dialogForm: {},

      mainData: {},
    };
  },
  watch: {},
  created() {},
  mounted() {
    let totalArr = [];
    //提取需要合计的字段
    for (var i = 0; i < this.tabelHeadeTitle.length; i++) {
      if (this.tabelHeadeTitle[i].isTotal) {
        totalArr.push(this.tabelHeadeTitle[i].field);
      }
    }
    this.totalArr = totalArr;
  },
  activated() {
    let waybillSplitId = this.$route.query.waybillSplitId || "";
    this.waybillNumber = this.$route.query.waybillNumber;
    if (waybillSplitId) {
      this.waybillSplitId = waybillSplitId;
      this.$API
        .wtl_getWaybillItems({ waybillSplitId: this.waybillSplitId })
        .then((res) => {
          this.tableData = res.data.result || [];

          this.tableData.forEach((item, index) => {
            this.myId = index;
            item.mid = index;
            item.address =
              item.provinceName + item.cityName + item.areaName + item.address;
          });
        });
    }
  },
  destroyed() {},
  methods: {
    goBack() {
      this.$TOOLS.closePage();
      this.$router.push({
        path: "/WaybillManage/ComprehensiveQuery",
        query: {
          isreload: "isreload",
        },
      });
    },
    submitBtns() {
      let that = this;
      let datas = JSON.parse(JSON.stringify(this.childWayList));
      if (datas.length < 2) {
        this.$message.error("至少需要拆成两个子单");
        return false;
      }
      if (this.tableData.length > 0) {
        this.$message.error("运单还没有拆完!");
        return false;
      }
      // let datas2 = {
      //   childTableData: JSON.parse(JSON.stringify(this.tableData)),
      // };
      // datas.push(datas2);

      let newArrs = [];
      datas.forEach((item, index) => {
        let arr1 = [];
        item.childTableData.forEach((item2, idx2) => {
          let obj = {
            billingWeight: item2.billingWeight * 1 || 0,
            grossWeight: item2.grossWeight * 1 || 0,
            netWeight: item2.netWeight * 1 || 0,
            oldItemId: item2.itemId * 1 || 0,
            oldTakeAddrId: item2.takeAddrId * 1 || 0,
            packageCout: item2.packageCout * 1 || 0,
            serialNumber: idx2 + 1 * 1 || 1,
            volume: item2.volume * 1 || 0,
            volumeWeight: item2.volumeWeight * 1 || 0,
          };
          arr1.push(obj);
        });

        let objs = {
          itemReqs: arr1,
          serialNumber: index + 1,
        };
        newArrs.push(objs);
      });
      let param = {
        childWaybillReqs: newArrs,
        oldWaybillSplitId: this.waybillSplitId,
      };

      this.$API.wtl_splitWaybill(param).then((res) => {
        this.$message.success(res.data.message || "拆单成功");
        setTimeout(() => {
          that.goBack();
        }, 1000);
      });
    },
    // 输入
    inputNums(num, idx, filed) {
      let mainData = JSON.parse(JSON.stringify(this.mainData));
      let totalNum = mainData[filed] * 1 || 0;
      // if (num && num.length > 1) {
      //   if (num[0] == "0") {
      //     num = num.substring(1, num.length);
      //   }
      // }
      num = num <= 0 && num != "" ? 0 : num;
      num = num > totalNum ? totalNum : num;
      this.tableData2[idx][filed] = num;
      this.tableData2[1 - idx][filed] = totalNum - num || 0;
    },
    handleSelectionChange(e) {
      // 表格选择事件
      this.selectTableData = e;
    },
    // 拆单按钮
    addBtns() {
      let selectData = JSON.parse(JSON.stringify(this.selectTableData || []));
      if (selectData.length == 0) {
        this.$message.warning("请选择需要拆分的货物");
        return false;
      }
      // if (selectData.length == this.tableData.length) {
      //   this.$message.warning("不能全部都拆成子运单");
      //   return false;
      // }

      let obj = {
        childTableData: selectData,
      };
      this.childWayList.push(obj);

      let datas = JSON.parse(JSON.stringify(this.tableData));
      for (var b = 0; b < selectData.length; b++) {
        for (var a = 0; a < datas.length; a++) {
          if (datas[a].mid == selectData[b].mid) {
            datas.splice(a, 1);
            a--;
          }
        }
      }

      this.tableData = datas;
    },

    delBtns(idx) {
      let items = JSON.parse(JSON.stringify(this.childWayList[idx] || {}));
      this.childWayList.splice(idx, 1);
      let arrs = items.childTableData || [];
      this.tableData = this.tableData.concat(arrs);
      // this.tableData.push();
    },

    chaiHuo(datas, idx) {
      console.log("datas", datas);
      if (datas.packageCout == 1) {
        this.$message.warning("货物件数为1,不能拆货");
        return false;
      }
      this.delIdx = idx || 0; //被待拆的行
      let row = JSON.parse(JSON.stringify(datas || ""));
      let goodsNumber = row.goodsNumber;

      this.mainData = row;
      this.isShowDialog = true;
      let arrs = [row];

      let objs = {
        goodsNumber: goodsNumber,
        goodsName: row.goodsName,
        packageCout: 0,
        grossWeight: 0,
        netWeight: 0,
        volumeWeight: 0,
        billingWeight: 0,
        volume: 0,
        mid: this.myId + 1,
        address: row.address,
        areaName: row.areaName,
        cityName: row.cityName,
        itemCategoryCode: row.itemCategoryCode,
        itemCategoryName: row.itemCategoryName,
        itemId: row.itemId,
        packageName: row.packageName,
        provinceName: row.provinceName,
        specs: row.specs,
        serialNumber: row.serialNumber,
        takeAddrId: row.takeAddrId,
        takeAddrNumber: row.takeAddrNumber,
      };
      this.myId++;
      arrs.push(objs);

      this.tableData2 = JSON.parse(JSON.stringify(arrs));
    },
    /***
     * ====== 弹窗组件方法 ======
     */
    //  弹窗关闭事件(左上角的x和关闭按钮都算)
    handleCloseDia() {
      this.isShowDialog = false;
    },
    //  弹窗确认保存事件
    diaConfirmBtn() {
      let tdatas = JSON.parse(JSON.stringify(this.tableData));
      tdatas.splice(this.delIdx, 1);
      tdatas = tdatas.concat(this.tableData2);
      this.tableData = tdatas;
      this.isShowDialog = false;
    },
    //  关闭弹窗按钮事件(关闭按钮)
    diaCancelBtn() {
      this.isShowDialog = false;
    },

    /***
     * ====== 弹窗组件方法 ======
     */
    // 表格合计
    getSummaries(param) {
      let that = this;
      const { columns, data } = param;

      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        for (var i = 0; i < that.totalArr.length; i++) {
          if (column.property === that.totalArr[i]) {
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                const value = Number(curr);
                if (!isNaN(value)) {
                  return this.$TOOLS.mathToFixed(
                    this.$TOOLS.add(prev, curr),
                    2
                  );
                } else {
                  return prev;
                }
              }, 0);
              sums[index] += "";
            } else {
              sums[index] = "---";
            }
          }
        }
      });
      this.$nextTick(() => {
        this.$refs.mytable.doLayout();
      });
      return sums;
    },
    // 点击选中当前行
    rowclick(row, event, column) {
      this.$refs.mytable.toggleRowSelection(row);
    },
  },
};
</script>
<style scoped lang='less'>
.glo_form .queryItems {
  /deep/ .el-input__inner {
    width: 200px;
  }
}

.h3title {
  background-color: #f2f2f2;
  padding: 10px;
  border-bottom: 1px solid #cccccc;
  font-weight: bold;
  // margin-bottom: 10px;
}

.chaiDanTit {
  // width: 100%;

  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 20px;

  .delBtn {
    background-color: #f00;
    color: #fff;
  }
}

.diaTopTitle {
  color: #000;
  font-size: 14px;
  .infoBox {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 10px;

    .infoItem {
      display: flex;
      align-items: center;
      margin-right: 20px;

      .infoRight {
        color: #f00;
      }
    }
  }
}

.saveBtns {
  width: 100%;
  text-align: center;
  margin: 50px auto;
}
</style>